import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { ComingSoon, ParametersList } from '@config/components';
import { useConfigContext } from '@config/context';

export const ParametersPage = (): ReactElement => {
  const { t } = useTranslation();
  const { getParameters } = useConfigContext();

  if (!getParameters) return <ComingSoon sectionKey="parameters" />;

  return (
    <Page>
      <Page.Title>{t('config.sections.parameters')}</Page.Title>
      <Page.Content fill>
        <ParametersList />
      </Page.Content>
    </Page>
  );
};
